export default "__VITE_ASSET__579a9298__"